import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallingScreenComponent } from './calling-screen/calling-screen.component';
import { CallingScreenBetaComponent } from './calling-screen-beta';
import { CallingScreenRoutingModule } from './calling-screen-routing.module';
import { KidCardComponent } from './kid-card/kid-card.component';
import { KidCardBetaComponent } from './kid-card-beta/kid-card-beta.component';
import { OwlModule } from 'ngx-owl-carousel';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Game Mode Components
import { MascotComponent } from './game-mode/components/mascot/mascot.component';
import { GameOverlayComponent } from './game-mode/components/game-overlay/game-overlay.component';
import { GameHubComponent } from './game-mode/components/game-hub/game-hub.component';
import { QuizContainerComponent } from './game-mode/components/quiz/quiz-container/quiz-container.component';
import { QuestionCardComponent } from './game-mode/components/quiz/question-card/question-card.component';
import { QuizTimerComponent } from './game-mode/components/quiz/quiz-timer/quiz-timer.component';
import { QuizResultComponent } from './game-mode/components/quiz/quiz-result/quiz-result.component';
import { QuizSummaryComponent } from './game-mode/components/quiz/quiz-summary/quiz-summary.component';
import { CreatureDisplayComponent } from './game-mode/components/creature/creature-display/creature-display.component';
import { CreaturePickerComponent } from './game-mode/components/creature/creature-picker/creature-picker.component';
import { CreatureProfileComponent } from './game-mode/components/creature/creature-profile/creature-profile.component';
import { XpBarComponent } from './game-mode/components/creature/xp-bar/xp-bar.component';
import { LevelUpEffectComponent } from './game-mode/components/creature/level-up-effect/level-up-effect.component';
import { SchoolMapComponent } from './game-mode/components/battle/school-map/school-map.component';
import { DailyBonusComponent } from './game-mode/components/shared/daily-bonus/daily-bonus.component';
import { LeagueBadgeComponent } from './game-mode/components/shared/league-badge/league-badge.component';
import { StreakDisplayComponent } from './game-mode/components/shared/streak-display/streak-display.component';
import { DismissalInterruptComponent } from './game-mode/components/shared/dismissal-interrupt/dismissal-interrupt.component';
import { SubjectPickerComponent } from './game-mode/components/shared/subject-picker/subject-picker.component';
import { GameCategoryPickerComponent } from './game-mode/components/shared/game-category-picker/game-category-picker.component';
import { FunGamesPickerComponent } from './game-mode/components/shared/fun-games-picker/fun-games-picker.component';
import { AcademicSubjectPickerComponent } from './game-mode/components/shared/academic-subject-picker/academic-subject-picker.component';
import { AcademicGamesPickerComponent } from './game-mode/components/shared/academic-games-picker/academic-games-picker.component';
import { RyderGuideComponent } from './game-mode/components/ryder-guide/ryder-guide.component';

// Mini-Game Components
import { GameSelectorComponent } from './game-mode/components/shared/game-selector/game-selector.component';
import { StudentAvatarComponent } from './game-mode/components/shared/student-avatar/student-avatar.component';
import { StudentSpotlightComponent } from './game-mode/components/shared/student-spotlight/student-spotlight.component';
import { SpinWheelComponent } from './game-mode/components/mini-games/spin-wheel/spin-wheel.component';
import { SpinWheelGameComponent } from './game-mode/components/mini-games/spin-wheel/spin-wheel-game.component';
import { TugOfWarTeamSetupComponent } from './game-mode/components/mini-games/tug-of-war/tug-of-war-team-setup.component';
import { TugOfWarGameComponent } from './game-mode/components/mini-games/tug-of-war/tug-of-war-game.component';
import { TugOfWarRopeComponent } from './game-mode/components/mini-games/tug-of-war/tug-of-war-rope.component';
import { TeamDisplayComponent } from './game-mode/components/mini-games/tug-of-war/team-display.component';
import { LightningRoundGameComponent } from './game-mode/components/mini-games/lightning-round/lightning-round-game.component';
import { ComboMeterComponent } from './game-mode/components/mini-games/lightning-round/combo-meter.component';
import { BombPassGameComponent } from './game-mode/components/mini-games/bomb-pass/bomb-pass-game.component';
import { BombVisualComponent } from './game-mode/components/mini-games/bomb-pass/bomb-visual.component';
import { MysteryBoxGameComponent } from './game-mode/components/mini-games/mystery-box/mystery-box-game.component';
import { MiniGameSummaryComponent } from './game-mode/components/mini-games/mini-game-summary/mini-game-summary.component';
import { LiveLeaderboardComponent } from './game-mode/components/shared/live-leaderboard/live-leaderboard.component';
import { ClassSelectComponent } from './game-mode/components/class-select/class-select.component';
import { StudentLoadingComponent } from './game-mode/components/student-loading/student-loading.component';
import { GameInfoModalComponent } from './game-mode/components/shared/game-info-modal/game-info-modal.component';
import { GameSoundControlComponent } from './game-mode/components/shared/game-sound-control/game-sound-control.component';
import { BowlingSetupComponent } from './game-mode/components/mini-games/bowling/bowling-setup.component';
import { BowlingGameComponent } from './game-mode/components/mini-games/bowling/bowling-game.component';
import { BowlingScorecardComponent } from './game-mode/components/mini-games/bowling/bowling-scorecard.component';
import { BowlingSceneComponent } from './game-mode/components/mini-games/bowling/bowling-scene.component';
import { BowlingSummaryComponent } from './game-mode/components/mini-games/bowling/bowling-summary.component';
import { SymmetryGameComponent } from './game-mode/components/mini-games/symmetry/symmetry-game.component';
import { SymmetryStageComponent } from './game-mode/components/mini-games/symmetry/symmetry-stage.component';
import { MatchUpGameComponent } from './game-mode/components/mini-games/match-up/match-up-game.component';
import { MatchUpStageComponent } from './game-mode/components/mini-games/match-up/match-up-stage.component';
import { FractionLineGameComponent } from './game-mode/components/mini-games/fraction-line/fraction-line-game.component';
import { FractionLineStageComponent } from './game-mode/components/mini-games/fraction-line/fraction-line-stage.component';
import { FractionHopsGameComponent } from './game-mode/components/mini-games/fraction-hops/fraction-hops-game.component';
import { FractionHopsStageComponent } from './game-mode/components/mini-games/fraction-hops/fraction-hops-stage.component';
import { FractionTrekGameComponent } from './game-mode/components/mini-games/fraction-trek/fraction-trek-game.component';
import { FractionTrekStageComponent } from './game-mode/components/mini-games/fraction-trek/fraction-trek-stage.component';
import { ZoomQuestGameComponent } from './game-mode/components/mini-games/zoom-quest/zoom-quest-game.component';
import { ZoomQuestStageComponent } from './game-mode/components/mini-games/zoom-quest/zoom-quest-stage.component';
import { TreasureGridGameComponent } from './game-mode/components/mini-games/treasure-grid/treasure-grid-game.component';
import { TreasureGridStageComponent } from './game-mode/components/mini-games/treasure-grid/treasure-grid-stage.component';
import { CubeFillGameComponent } from './game-mode/components/mini-games/cube-fill/cube-fill-game.component';
import { CubeFillStageComponent } from './game-mode/components/mini-games/cube-fill/cube-fill-stage.component';
import { BalanceItGameComponent } from './game-mode/components/mini-games/balance-it/balance-it-game.component';
import { BalanceItStageComponent } from './game-mode/components/mini-games/balance-it/balance-it-stage.component';
import { PowerBurstGameComponent } from './game-mode/components/mini-games/power-burst/power-burst-game.component';
import { PowerBurstStageComponent } from './game-mode/components/mini-games/power-burst/power-burst-stage.component';
import { CuttingPizzaGameComponent } from './game-mode/components/mini-games/cutting-pizza/cutting-pizza-game.component';
import { CuttingPizzaStageComponent } from './game-mode/components/mini-games/cutting-pizza/cutting-pizza-stage.component';
import { VaultCrackerGameComponent } from './game-mode/components/mini-games/vault-cracker/vault-cracker-game.component';
import { VaultCrackerStageComponent } from './game-mode/components/mini-games/vault-cracker/vault-cracker-stage.component';
import { FullscreenToggleComponent } from './game-mode/components/mini-games/_shared/fullscreen-toggle.component';


@NgModule({
  declarations: [
    CallingScreenComponent,
    CallingScreenBetaComponent,
    KidCardComponent,
    KidCardBetaComponent,
    // Game Mode
    MascotComponent,
    GameOverlayComponent,
    GameHubComponent,
    QuizContainerComponent,
    QuestionCardComponent,
    QuizTimerComponent,
    QuizResultComponent,
    QuizSummaryComponent,
    CreatureDisplayComponent,
    CreaturePickerComponent,
    CreatureProfileComponent,
    XpBarComponent,
    LevelUpEffectComponent,
    SchoolMapComponent,
    DailyBonusComponent,
    LeagueBadgeComponent,
    StreakDisplayComponent,
    DismissalInterruptComponent,
    SubjectPickerComponent,
    GameCategoryPickerComponent,
    FunGamesPickerComponent,
    AcademicSubjectPickerComponent,
    AcademicGamesPickerComponent,
    RyderGuideComponent,
    // Mini-Games
    GameSelectorComponent,
    StudentAvatarComponent,
    StudentSpotlightComponent,
    SpinWheelComponent,
    SpinWheelGameComponent,
    TugOfWarTeamSetupComponent,
    TugOfWarGameComponent,
    TugOfWarRopeComponent,
    TeamDisplayComponent,
    LightningRoundGameComponent,
    ComboMeterComponent,
    BombPassGameComponent,
    BombVisualComponent,
    MysteryBoxGameComponent,
    MiniGameSummaryComponent,
    LiveLeaderboardComponent,
    ClassSelectComponent,
    StudentLoadingComponent,
    GameInfoModalComponent,
    GameSoundControlComponent,
    BowlingSetupComponent,
    BowlingGameComponent,
    BowlingScorecardComponent,
    BowlingSceneComponent,
    BowlingSummaryComponent,
    SymmetryGameComponent,
    SymmetryStageComponent,
    MatchUpGameComponent,
    MatchUpStageComponent,
    FractionLineGameComponent,
    FractionLineStageComponent,
    FractionHopsGameComponent,
    FractionHopsStageComponent,
    FractionTrekGameComponent,
    FractionTrekStageComponent,
    ZoomQuestGameComponent,
    ZoomQuestStageComponent,
    TreasureGridGameComponent,
    TreasureGridStageComponent,
    CubeFillGameComponent,
    CubeFillStageComponent,
    BalanceItGameComponent,
    BalanceItStageComponent,
    PowerBurstGameComponent,
    PowerBurstStageComponent,
    CuttingPizzaGameComponent,
    CuttingPizzaStageComponent,
    VaultCrackerGameComponent,
    VaultCrackerStageComponent,
    FullscreenToggleComponent
  ],
  exports: [
    // Exported for the dev-only game-preview harness (gated out of prod).
    GameOverlayComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    CallingScreenRoutingModule,
    // OwlModule,
    CarouselModule,
    TranslateModule,
    SharedModule,
    MatSelectModule,
    FormsModule,
    NgbTooltipModule,
    DragDropModule
  ]
})
export class CallingScreenModule { }
